import { postAsync } from '../api/api';
import { MiddlewareAPI } from 'redux';
import { getTimestamp } from 'common/utils/get-timestamp';
import { TrackingImpressionRequest } from '../types';
import Cookies from 'universal-cookie';
import { getEnv, getOrchestratorHost, getApiKey, getApiOption } from 'common/selectors';
import { getLang } from 'utils';
import { buildUrl } from 'features/api';

export const buildTrackingPayload = (impressionContentId: string) => {
  const cookies = new Cookies(document.cookie);
  const sessionValue = cookies.get('rm_session') ?? '';

  return {
    link: { name: 'session', value: sessionValue },
    impressionContentId,
    timestamp: getTimestamp(),
  };
};

export const sendTrackingImpressionView = async (store: MiddlewareAPI, impressionContentId: string) => {
  await postAsync<unknown, TrackingImpressionRequest>(
    store,
    'tracking/impression/view',
    buildTrackingPayload(impressionContentId),
    {
      headers: { 'Content-Type': 'application/json' },
    },
  );
};

export const sendTrackingImpressionClick = (store: MiddlewareAPI, impressionContentId: string) => {
  const state = store.getState();
  const { requestID, USE_CREDENTIALS } = getEnv(state);
  const orchestratorHost = getOrchestratorHost(state);
  const apiKey = getApiKey(state);
  const apiOption = getApiOption(state);
  const lang = getLang();

  const url = buildUrl(orchestratorHost ?? '', 'tracking/impression/click', { lang });
  const payload = buildTrackingPayload(impressionContentId);

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (requestID) {
    headers['x-request-id'] = requestID;
  }

  if (apiKey) {
    headers['x-api-key'] = apiKey;
  }

  if (apiOption) {
    headers['x-api-option'] = apiOption;
  }

  fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
    keepalive: true,
    credentials: USE_CREDENTIALS ? 'include' : 'same-origin',
  });
};
